import { jwtDecode } from 'jwt-decode';

/**
 * True while the stored access token is a 2FA user's password-only sign-in token: the API refuses it
 * on every route but POST /auth-consumers-2fa/authenticate until that step succeeds.
 */
export const isTwoFactorPending = token => {
    try {
        const claims = jwtDecode(token);
        return Boolean(claims.isTwoFactorEnable && !claims.isTwoFactorAuthenticated);
    } catch (error) {
        return false;
    }
};
